import { Environments } from "types/common-types";

export const isEnvironment = (environment: string | undefined, expected: Environments) =>
  environment?.toLowerCase() === expected;
